<script>
import PhoneNumber from "@/components/phones/PhoneNumber.vue";
import LanguageTag from "@/components/statuses/LanguageTag.vue";
import OpenChatButton from "@/components/buttons/OpenChatButton.vue";

export default {
  name: "SidebarUserBlock",
  components: { OpenChatButton, LanguageTag, PhoneNumber },
  props: {
    isContactPerson: Boolean,
    fullAccess: Boolean,
    label: String,
    user: Object,
  },
};
</script>

<template>
  <div v-if="user" class="user-info__block w-100 pt-5 pb-5">
    <div class="user-info__block-content">
      <div class="text-grey-darken-3 mb-2">{{ label }}</div>
      <div class="d-flex align-center">
        <span v-if="isContactPerson" class="currency-icon mr-3"></span>
        <router-link
          :to="{ name: 'user-view', params: { id: user.id } }"
          class="text-primary text-decoration-none font-weight-500"
          data-qa="sidebar-user-block-name"
        >
          {{ user.name }}
        </router-link>
        <div v-if="fullAccess" class="text-green ml-3" data-qa="sidebar-user-block-full-acces">
          <v-icon size="small">mdi-check</v-icon>
        </div>

        <open-chat-button :user="user" class="ml-auto" />
      </div>
      <div class="d-flex align-center mt-2 mb-2">
        <phone-number
          v-if="user.phone"
          :number="user.phone"
          class="text-primary mr-2"
          data-qa="sidebar-user-block-phone"
          is-callable
        />
        <language-tag v-if="user.language" :language="user.language"></language-tag>
      </div>
      <div v-if="user.email" class="caption mb-2">
        <a
          v-clipboard="user.email"
          class="font-size-12 text-primary text-decoration-none"
          data-qa="sidebar-user-block-email"
        >
          {{ user.email }}
        </a>
      </div>
      <div class="d-flex mt-2">
        <div
          v-if="user.isOwner"
          class="d-inline-block mb-2 bg-grey-lighten-4 rounded-lg px-2 mr-2"
          data-qa="sidebar-user-block-owner"
        >
          <span class="text-blue-lighten-2 caption text-uppercase text-green-lighten-2">Owner</span>
        </div>
        <div
          v-if="user.isCoordinator"
          class="d-inline-block mb-2 bg-grey-lighten-4 rounded-lg px-2"
          data-qa="sidebar-user-block-owner"
        >
          <span class="text-blue-lighten-2 caption text-uppercase text-blue-lighten-2">Coordinator</span>
        </div>
      </div>
    </div>
  </div>
</template>
